import { useEffect, useState } from 'react';
import api from '../api/client';
import {
  LayoutDashboard, Package, ShoppingCart, Users, Truck, MessageSquare,
  Wallet, Settings, Activity, BookOpen, Warehouse, Tag, BookMarked, ShoppingBag, LayoutGrid, Building2,
  UserCheck, CalendarDays, FileText, Star, Calendar, CreditCard, HelpCircle, KeyRound, Landmark, MapPin, Receipt,
  ClipboardList, Lock, PieChart, CalendarClock, Trophy, Folder, Briefcase, Heart, Flag, Shield, Megaphone,
} from 'lucide-react';

// Menu laterale staff riordinabile da ROOT (Impostazioni → Menu laterale, 23/10/2026).
// VOCI = catalogo fisso: indirizzo, icona e PERMESSO di ogni pagina restano qui nel codice.
// Il layout salvato sul server dice solo dove stanno le voci e come si chiamano, quindi spostare
// una voce non cambia mai chi la vede (un menu sparisce se per quell'utente resta vuoto).
//
// PRODOTTI/ORDINI: i permessi sono sui singoli figli (vedi CLAUDE.md 8-sedecies).
// DIPENDENTI: anagrafica/rimborsi/listino/template = "dipendenti", calendario/riepilogo/paghe = "presenze".
// CASSA: movimenti = "banca", centri = "cassa", moduli distinti lato server.
// Password manager: solo ROOT + permesso esplicito (server: permessoVault, rilegge il ruolo dal DB).
export const VOCI = [
  // Dashboard: visibile se il ruolo ha almeno una delle sezioni che contiene (array = basta uno)
  { path: '/', label: 'DASHBOARD', icon: LayoutDashboard, exact: true, requirePermesso: ['compiti','calendario','ordini','prodotti','banca'] },
  // Calendario attività (25/10/2026): eventi della società con sede/tag/visibilità (non le presenze allenatori)
  { path: '/calendario', label: 'CALENDARIO', icon: CalendarDays, requirePermesso: 'calendario' },
  // Supporto: richieste di utenti e allenatori dal portale (contatore = in attesa di risposta)
  { path: '/supporto', label: 'SUPPORTO', icon: MessageSquare, requirePermesso: 'ticket' },
  // FIPAV vista società (solo col permesso); il sottomenu è dentro la pagina
  { path: '/tornei-fipav', label: 'FIPAV', icon: Trophy, requirePermesso: 'fipav' },
  // AIBVC (23/10/2026): menu con i tornei (Club Series → stagioni → squadre/giornate) e le società AIBVC
  { path: '/aibvc/club-series', label: 'Club Series', icon: Trophy, requirePermesso: 'aibvc' },
  // 29/10: tornei a coppie di aibvc.app (CNT e AIBVC Tour), sola consultazione
  { path: '/aibvc/tornei-cnt-l', label: 'Tornei CNT & L', icon: Flag, requirePermesso: 'aibvc' },
  { path: '/aibvc/societa', label: 'Società AIBVC', icon: Users, requirePermesso: 'aibvc' },
  { path: '/products/catalog',    label: 'Catalogo',   icon: BookOpen,   requirePermesso: 'prodotti' },
  { path: '/products/warehouse',  label: 'Magazzino',  icon: Warehouse,  requirePermesso: 'prodotti' },
  { path: '/products/categories', label: 'Categorie',  icon: Tag,        requirePermesso: 'prodotti' },
  { path: '/products/variants',   label: 'Varianti',   icon: BookMarked, requirePermesso: 'prodotti' },
  { path: '/suppliers',                 label: 'Fornitori',       icon: Truck,       requirePermesso: 'fornitori' },
  { path: '/suppliers/purchase-orders', label: 'Ordini acquisto', icon: ShoppingBag, requirePermesso: 'fornitori' },
  { path: '/orders',           label: 'Ordini vendita', icon: ShoppingCart, requirePermesso: 'ordini' },
  { path: '/orders/new',       label: 'Nuovo ordine',   icon: ShoppingBag,  requirePermesso: 'ordini' },
  { path: '/customers',        label: 'Clienti',        icon: Users, requirePermesso: 'clienti' },
  { path: '/customers/groups', label: 'Gruppi clienti', icon: Tag,   requirePermesso: 'clienti' },
  { path: '/planning', label: 'Planning corsi', icon: Calendar, requirePermesso: 'planning' },
  { path: '/campi',    label: 'Affitto campi',  icon: MapPin,   requirePermesso: 'campi' },
  { path: '/dipendenti',            label: 'Anagrafica',   icon: UserCheck,    requirePermesso: 'dipendenti' },
  { path: '/dipendenti/calendario', label: 'Calendario',   icon: CalendarDays, requirePermesso: 'presenze'   },
  { path: '/dipendenti/riepilogo',  label: 'Riepilogo mensile', icon: ClipboardList, requirePermesso: 'presenze' },
  { path: '/dipendenti/paghe',      label: 'Paghe mensili', icon: CreditCard, requirePermesso: 'presenze' },
  { path: '/dipendenti/rimborsi',  label: 'Rimborsi',     icon: Receipt,      requirePermesso: 'dipendenti' },
  { path: '/dipendenti/listino',    label: 'Listino att.', icon: Star,         requirePermesso: 'dipendenti' },
  { path: '/dipendenti/template',   label: 'Template',     icon: FileText,     requirePermesso: 'dipendenti' },
  { path: '/dipendenti/contratti',  label: 'Contratti',    icon: FileText,     requirePermesso: 'dipendenti' },
  { path: '/cash/banca', label: 'Movimenti bancari', icon: Building2, requirePermesso: 'banca' },
  { path: '/corsisti',   label: 'Pagamento corsi', icon: CreditCard, requirePermesso: 'pagamento_corsi' },
  { path: '/contabilita-corsi', label: 'Contabilità corsi', icon: PieChart, requirePermesso: 'contabilita_corsi' },
  { path: '/contabilita-tornei', label: 'Contabilità tornei', icon: Trophy, requirePermesso: 'tornei' },
  { path: '/ricevute-asd', label: 'Ricevute ad altre ASD', icon: Receipt, requirePermesso: 'ricevute_asd' },
  { path: '/cash/centri', label: 'Centri costo/ricavo', icon: Landmark, requirePermesso: 'cassa' },
  { path: '/cash/resoconto', label: 'Resoconto spese', icon: PieChart, requirePermesso: 'banca' },
  { path: '/business-plan', label: 'Business plan', icon: Briefcase, requirePermesso: 'business_plan' },
  { path: '/cash/spese-ricorrenti', label: 'Piano spese', icon: CalendarClock, requirePermesso: 'banca' },
  { path: '/anagrafica',   label: 'Anagrafica persone', icon: Users, requirePermesso: 'anagrafica' },
  { path: '/form',         label: 'Form',               icon: ClipboardList, requirePermesso: 'form' },
  { path: '/strutture',    label: 'Contratti strutture', icon: MapPin, requirePermesso: 'strutture' },
  { path: '/organizzazione', label: 'Organizzazione', icon: Building2, requirePermesso: 'organizzazione' },
  { path: '/segreteria',   label: 'Segreteria ASD', icon: BookOpen,   requirePermesso: 'segreteria' },
  { path: '/tesseramenti', label: 'Tesseramenti',   icon: CreditCard, requirePermesso: 'tesseramenti' },
  { path: '/settings',         label: 'Impostazioni',      icon: Settings,   requirePermesso: 'impostazioni' },
  { path: '/settings/widgets', label: 'Dashboard cliente', icon: LayoutGrid, requirePermesso: 'dashboard_cliente' },
  { path: '/password-manager', label: 'Password manager',  icon: KeyRound,   requirePermesso: 'password_manager' },
  { path: '/changelog',        label: 'Changelog',         icon: Activity,   requirePermesso: 'changelog' },
  { path: '/guida',            label: 'Guida operativa',   icon: HelpCircle, requirePermesso: 'guida' },
  { path: '/cambia-password',  label: 'Cambia password',   icon: Lock },
];
export const VOCE = Object.fromEntries(VOCI.map(v => [v.path, v]));

// Voci da allenatore: compaiono in cima solo in modalità allenatore. Ordine e nomi seguono il menu
// del portale allenatori (useVociAllenatoreStaff): portale = la stessa voce in quel menu.
export const VOCI_ALLENATORE = [
  { path: '/le-mie-presenze', portale: '/allenatore', label: 'LE MIE PRESENZE',   icon: CalendarDays, exact: true },
  { path: '/le-mie-presenze/contratti', portale: '/allenatore/contratti', label: 'I MIEI CONTRATTI', icon: FileText, exact: true },
  { path: '/le-mie-presenze/documenti', portale: '/allenatore/documenti', label: 'I MIEI DOCUMENTI', icon: FileText, exact: true },
  { path: '/le-mie-presenze/anagrafica', portale: '/allenatore/anagrafica', label: 'I MIEI DATI', icon: UserCheck, exact: true },
  { path: '/le-mie-presenze/tessera', portale: '/cliente/tessera', label: 'LA MIA TESSERA', icon: CreditCard, exact: true },
  { path: '/le-mie-presenze/allenatori', portale: '/calendario-allenatori', label: 'CALENDARIO ALLENATORI', icon: ClipboardList, exact: true },
  { path: '/le-mie-presenze/rimborsi', portale: '/allenatore/rimborsi', label: 'I MIEI RIMBORSI', icon: Receipt, exact: true },
  { path: '/le-mie-presenze/guida', portale: '/allenatore/guida', label: 'GUIDA ALLENATORI', icon: HelpCircle, exact: true },
  // FIPAV da atleta (vista personale): lo staff con permesso fipav gestisce da /tornei-fipav in modalità staff
  { path: '/le-mie-presenze/fipav', portale: '/cliente/fipav', label: 'TORNEI FIPAV', icon: Trophy },
  { path: '/le-mie-presenze/aibvc', portale: '/cliente/aibvc', label: 'LA MIA SQUADRA AIBVC', icon: Flag },
];

// Icone sceglibili per i menu (il nome è quello salvato sul server)
export const ICONE = {
  Package, ShoppingCart, Calendar, UserCheck, Wallet, BookOpen, Settings, Trophy, Users, Folder,
  Briefcase, Star, Heart, Flag, Shield, Megaphone, KeyRound, MapPin, CreditCard, PieChart, ClipboardList, FileText,
};

// Il menu com'era scritto nel codice: è anche quello di "Ripristina menu originale"
export const LAYOUT_PREDEFINITO = {
  voci: [
    { tipo: 'voce', path: '/' },
    { tipo: 'voce', path: '/calendario' },
    { tipo: 'voce', path: '/supporto' },
    { tipo: 'voce', path: '/tornei-fipav' },
    { tipo: 'gruppo', id: 'aibvc', label: 'AIBVC', icon: 'Flag', figli: ['/aibvc/club-series','/aibvc/tornei-cnt-l','/aibvc/societa'] },
    { tipo: 'gruppo', id: 'prodotti', label: 'PRODOTTI E FORNITORI', icon: 'Package',
      figli: ['/products/catalog','/products/warehouse','/products/categories','/products/variants','/suppliers','/suppliers/purchase-orders'] },
    { tipo: 'gruppo', id: 'ordini', label: 'ORDINI E CLIENTI', icon: 'ShoppingCart',
      figli: ['/orders','/orders/new','/customers','/customers/groups'] },
    { tipo: 'gruppo', id: 'corsi', label: 'CORSI E CAMPI', icon: 'Calendar', figli: ['/planning','/campi'] },
    { tipo: 'gruppo', id: 'dipendenti', label: 'DIPENDENTI', icon: 'UserCheck',
      figli: ['/dipendenti','/dipendenti/calendario','/dipendenti/riepilogo','/dipendenti/paghe','/dipendenti/rimborsi','/dipendenti/listino','/dipendenti/template','/dipendenti/contratti'] },
    { tipo: 'gruppo', id: 'cassa', label: 'CASSA', icon: 'Wallet',
      figli: ['/cash/banca','/corsisti','/contabilita-corsi','/contabilita-tornei','/ricevute-asd','/cash/centri','/cash/resoconto','/business-plan','/cash/spese-ricorrenti'] },
    { tipo: 'gruppo', id: 'associazione', label: 'ASSOCIAZIONE', icon: 'BookOpen',
      figli: ['/anagrafica','/form','/strutture','/segreteria','/tesseramenti','/organizzazione'] },
    { tipo: 'gruppo', id: 'impostazioni', label: 'IMPOSTAZIONI', icon: 'Settings',
      figli: ['/settings','/settings/widgets','/password-manager','/changelog','/guida','/cambia-password'] },
  ],
  nomi: {},
};

// Dove andrebbe una voce secondo il menu predefinito (per le pagine nuove non ancora sistemate)
const gruppoPredefinito = (path) => LAYOUT_PREDEFINITO.voci.find(v => v.tipo === 'gruppo' && v.figli.includes(path))?.id;

// Layout salvato (o null) → layout completo e pulito: voci sconosciute tolte, voci mancanti
// rimesse nel loro menu predefinito se esiste ancora, altrimenti in fondo al primo livello.
export const completaLayout = (salvato) => {
  if (!salvato?.voci) return LAYOUT_PREDEFINITO;
  const visti = new Set();
  const tieni = (p) => VOCE[p] && !visti.has(p) && visti.add(p);
  const voci = salvato.voci
    .filter(v => v.tipo === 'gruppo' || tieni(v.path))
    .map(v => v.tipo === 'gruppo' ? { ...v, figli: (v.figli || []).filter(tieni) } : v);
  for (const { path } of VOCI) {
    if (visti.has(path)) continue;
    const id = gruppoPredefinito(path);
    const g = voci.find(v => v.tipo === 'gruppo' && v.id === id);
    if (g) { g.figli.push(path); continue; }
    // menu nuovo (es. AIBVC) che il layout salvato non ha ancora: si aggiunge in fondo con le sue voci
    const nuovo = id && LAYOUT_PREDEFINITO.voci.find(v => v.tipo === 'gruppo' && v.id === id);
    if (nuovo) voci.push({ ...nuovo, figli: [path] }); else voci.push({ tipo: 'voce', path });
  }
  return { voci, nomi: salvato.nomi || {} };
};

// Layout → struttura disegnata dalla sidebar (stessa forma del vecchio array NAV)
export const costruisciNav = (layout) => {
  const l = completaLayout(layout);
  const conNome = (p) => ({ ...VOCE[p], label: l.nomi[p] || VOCE[p].label });
  return l.voci.map(v => v.tipo === 'gruppo'
    ? { id: v.id, label: v.label, icon: ICONE[v.icon] || Folder, children: v.figli.map(conNome) }
    : conNome(v.path));
};

// Layout dal server per ambito (STAFF, UTENTE, ALLENATORE), condiviso tra sidebar ed editor;
// si ricarica dopo un salvataggio. undefined = non ancora chiesto, null = menu predefinito.
const cache = {};
const inCorso = {};
const ascoltatori = {};
export const ricaricaMenu = (ambito) => {
  if (!inCorso[ambito]) {
    inCorso[ambito] = api.get(`/menu/${ambito}`)
      .then(r => {
        // stesso contenuto = stesso oggetto: l'editor riparte da capo solo se il menu è cambiato davvero
        const nuovo = r.data?.layout || null;
        if (JSON.stringify(nuovo) !== JSON.stringify(cache[ambito])) cache[ambito] = nuovo;
      })
      .catch(() => { cache[ambito] = cache[ambito] ?? null; })
      .finally(() => { inCorso[ambito] = null; (ascoltatori[ambito] || new Set()).forEach(f => f(cache[ambito])); });
  }
  return inCorso[ambito];
};
export const useMenu = (ambito) => {
  const [layout, setLayout] = useState(cache[ambito] ?? null);
  useEffect(() => {
    if (!ascoltatori[ambito]) ascoltatori[ambito] = new Set();
    ascoltatori[ambito].add(setLayout);
    if (cache[ambito] === undefined) ricaricaMenu(ambito); else setLayout(cache[ambito]);
    // un menu cambiato da ROOT arriva a chi ha già il gestionale aperto: al ritorno sulla scheda e ogni 5 minuti
    const ricontrolla = () => { if (document.visibilityState === 'visible') ricaricaMenu(ambito); };
    document.addEventListener('visibilitychange', ricontrolla);
    const timer = setInterval(ricontrolla, 5 * 60 * 1000);
    return () => { ascoltatori[ambito].delete(setLayout); document.removeEventListener('visibilitychange', ricontrolla); clearInterval(timer); };
  }, [ambito]);
  return layout;
};
export const ricaricaMenuStaff = () => ricaricaMenu('STAFF');
export const useMenuStaff = () => useMenu('STAFF');
